import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import nds from '@nerdwallet/base-styles/classes';
import {
  setTrk,
  TrkTag,
  TrkElement,
} from '@nerdwallet/nw-client-lib/trk-helper';
import { Body, Legal } from '@nerdwallet/react-typography';
import autoInsuranceIcon from './icons/auto-insurance';
import bankingIcon from './icons/banking';
import creditCardIcon from './icons/credit-card';
import investingIcon from './icons/investing';
import mortgagesIcon from './icons/mortgages';
import personalLoansIcon from './icons/personal-loans';
import studentLoansIcon from './icons/student-loans';
import taxesIcon from './icons/taxes';
import travelRewardsIcon from './icons/travel-rewards';

import styles from './tile.module.less';

export const ICONS = {
  autoInsurance: autoInsuranceIcon,
  banking: bankingIcon,
  creditCards: creditCardIcon,
  investing: investingIcon,
  mortgages: mortgagesIcon,
  personalLoans: personalLoansIcon,
  studentLoans: studentLoansIcon,
  taxes: taxesIcon,
  travelRewards: travelRewardsIcon,
};

const Tile = ({
  className,
  comingSoon,
  icon,
  linkUrl,
  sectionCategory,
  title,
}) => {
  const modifiedUrl = linkUrl
    ? setTrk({
        url: linkUrl,
        params: {
          [TrkTag.copy]: title,
          [TrkTag.element]: TrkElement.hyperlink,
          [TrkTag.location]: 'Tile',
          [TrkTag.sectionCategory]: sectionCategory,
        },
      })
    : undefined;

  const IconComponent = _.get(ICONS, icon);

  // Deliberately use <a> instead of <Link> since the latter adds unwanted styling.
  const LinkComponent = comingSoon ? 'div' : 'a';

  return (
    <LinkComponent
      disabled={comingSoon}
      href={comingSoon ? null : modifiedUrl}
      className={classNames([
        styles.tile,
        comingSoon && styles.comingSoon,
        className,
      ])}
    >
      <div className={styles.iconContainer}>
        {IconComponent && <IconComponent />}
      </div>
      <div className={styles.textWrapper}>
        <Body
          className={classNames([
            styles.tileText,
            {
              [nds('color-neutral-lighter')]: comingSoon,
            },
          ])}
        >
          {title}
        </Body>
        {comingSoon && (
          <Legal className={styles.comingSoonText}>Coming soon!</Legal>
        )}
      </div>
    </LinkComponent>
  );
};

Tile.propTypes = {
  className: PropTypes.string,
  comingSoon: PropTypes.bool,
  icon: PropTypes.oneOf(_.keys(ICONS)),
  linkUrl: PropTypes.string,
  sectionCategory: PropTypes.string,
  title: PropTypes.string,
};

Tile.defaultProps = {
  className: '',
  comingSoon: false,
  icon: 'autoInsurance',
  title: 'Insert title here',
};

Tile.displayName = 'Tile';

export default Tile;
